import React from 'react';
import PropTypes from 'prop-types';
import AccountCircle from '@material-ui/icons/AccountCircle';
import { Grid, TextField, InputAdornment } from '@material-ui/core';

export const testId = 'tid';

export function UsernameImpl({ value, setValue }) {
  return (
    <Grid item xs={12}>
      <TextField
        required
        value={value}
        onChange={(e) => setValue(e.target.value)}
        type="text"
        name="username"
        placeholder="jdoe"
        style={{
          width: '100%',
        }}
        label="Username"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <AccountCircle />
            </InputAdornment>
          ),
        }}
        data-test={testId}
      />
    </Grid>
  );
}

UsernameImpl.propTypes = {
  value: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired,
};

export default (UsernameImpl);
